<h1>{{mainText}}</h1>
<br>
<input class="inputText" type="text" [(ngModel)] ="inputText"/>
<div style="width: 100%; text-align:center;">
  <button [disabled]="inputText == ''" (click)="CloseWithValue(inputText)">{{confirmText}}</button>
  <button *ngIf="canCancel;" (click)="CloseWithValue(null)">{{cancelText}}</button>
</div>
